import { render, staticRenderFns } from "./EventFieldContent.vue?vue&type=template&id=56304273"
import script from "./EventFieldContent.vue?vue&type=script&lang=js"
export * from "./EventFieldContent.vue?vue&type=script&lang=js"
import style0 from "./EventFieldContent.vue?vue&type=style&index=0&id=56304273&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports